export const SENDING_REQUEST = 'TREETEMPLATESLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'TREETEMPLATESLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'TREETEMPLATESLIST_GETALL_FAILURE';